module.exports = __webpack_public_path__ + "img/T1D_xh17.00d1fbc4.png";